// Keys panel: the keyboard shortcuts of the controls.

import { defineFeature } from "../../../registry";
import { el } from "../dom";
import { shortcuts } from "../strings";
import { strings } from "./strings";

export default defineFeature({
  id: "keys",
  title: strings.title,
  slot: "panel",
  order: 900,
  mount({ root }) {
    const list = el("dl", { class: "panel-keys" });
    for (const s of shortcuts) list.append(el("dt", {}, el("kbd", {}, s.label)), el("dd", {}, s.action));
    root.append(el("p", { class: "panel-note" }, strings.intro), list);
  },
});
